import React, { useState } from "react";
import { Reveal } from "../shared/Reveal";

const FAQS = [
  ["Who are Energy Vault Group?", "An independent energy-intelligence partner helping organisations see and cut waste across their entire estate."],
  ["What do you actually do?", "We make the invisible visible: measuring energy, water, carbon, occupancy and critical equipment in real time, minute by minute."],
  ["How is this different to a normal energy audit?", "We don't assume, we measure. Continuous live data across every site, not a one-off snapshot or estimate."],
  ["What does it cost to find out?", "Nothing to begin. We start with a no-cost Gap Analysis before any investment is discussed."],
  ["What's the benefit to my organisation?", "Typically up to 29% less wasted energy, audit-ready ESG & carbon reporting, and fewer unexpected asset failures."],
  ["What's the first step?", "A short conversation and your free Gap Analysis, with no commitment."],
];

export default function FAQ() {
  const [open, setOpen] = useState(0);
  return (
    <section id="faq" className="faq">
      <div className="wrap">
        <Reveal className="eyebrow" tag="div">KNOWLEDGE BEFORE INVESTMENT</Reveal>
        <Reveal className="h2" tag="div">Your Questions, <span className="g">Answered.</span></Reveal>
        <div className="faqlist">
          {FAQS.map(([q, a], i) => (
            <Reveal className="rv" tag="div" key={q}>
              <div className={`faqitem ${open === i ? "open" : ""}`} data-testid={`faq-item-${i}`}>
                <button className="faqq" onClick={() => setOpen(open === i ? -1 : i)} data-testid={`faq-question-${i}`} aria-expanded={open === i}>
                  <span><span className="qn">{i + 1}.</span>{q}</span>
                  <span className="faqchev">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" /></svg>
                  </span>
                </button>
                <div className="faqa" data-testid={`faq-answer-${i}`}><p>{a}</p></div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
